<template>
    <Transition name="pop">
        <div class="pop" v-if="show">
            <div class="content">
                <span class="close" @click="show = false"></span>
                <div class="header"></div>
                <div class="middle"></div>
                <div class="footer"></div>
                <h1>活动规则</h1>
                <div class="row">
                    <span>1、</span>
                    <p>活动时间：9月7日-9月10日23:59:59</p>
                </div>
                <div class="row">
                    <span>2、</span>
                    <p>
                        在活动页面上绑定新服角色名并发起新服预约招募，可选择加入其他兄弟团，或者自己成为团长
                    </p>
                </div>
                <div class="row">
                    <span>3、</span>
                    <p>
                        每个兄弟团成员上限：5人，招募期间团长可解散队伍，团员可退出队伍，一旦解除后24小时内无法加入其他兄弟团
                    </p>
                </div>
                <div class="row">
                    <span>4、</span>
                    <p>
                        首次加入任意兄弟团后即可获得【兄弟相邀礼包】，首次成团满员即可获得【兄弟成团礼包】，相关奖励可在开服后在天风大陆新区福利使者处领取
                    </p>
                </div>
                <div class="row">
                    <span>5、</span>
                    <p>
                        好友邀请：玩家可将页面中自己的团队邀请码与活动页面转发给好友，待好友完成角色绑定与邀请码填写后，视为邀请成功
                    </p>
                </div>
                <div class="row">
                    <span>6、</span>
                    <p>同ip下参与预约绑定的账号最多为3个通行证账号</p>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { ref } from "vue";

const show = ref(false);

defineExpose({
    Show: () => {
        show.value = true;
    }
});
</script>

<style lang="scss" scoped></style>
